<template>
  <BlockFieldset class="project-bank-self-disclosure">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <div v-else>
      <p class="bank-section-intro mb-2">{{ $t('bankSelfDisclosureInstructions') }}</p>
      <div class="bank-section-grid bank-section-grid--paired">
        <div class="label">{{ $t('bankSelfDisclosureDownload') }}</div>
        <div>
          <a :href="BANK_SELF_DISCLOSURE_TEMPLATE_PATH" download target="_blank">
            <i class="fa fa-download mr-2"></i>{{ $t('bankSelfDisclosureDownload') }}
          </a>
        </div>
        <template v-for="row in ATTACHMENT_ROWS">
          <div class="label" :key="`${row.attachmentType}-label`">{{ $t(row.labelKey) }}</div>
          <div :key="row.attachmentType">
            <BankAttachmentUpload
              :project="project"
              :attachmentType="row.attachmentType"
              @changed="reloadBlock"
            />
          </div>
        </template>
      </div>
    </div>
  </BlockFieldset>
</template>

<script>
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import BankAttachmentUpload from '@/components/Projects/BankAttachmentUpload';
import {
  BANK_ATTACHMENT_TYPES,
  BANK_SELF_DISCLOSURE_TEMPLATE_PATH,
} from '@/helpers/bankAttachmentTypes';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { ProjectBankBlockMixin } from '@/mixins/projectBankBlock';
import { PROJECT_BANK_SELF_DISCLOSURE_FIELDS } from './projectBankSelfDisclosureFragment';

/** Documents of the section in the order of the previous tab. */
const ATTACHMENT_ROWS = [
  {
    labelKey: 'bankAttachmentSelfDisclosure',
    attachmentType: BANK_ATTACHMENT_TYPES.BANK_SELF_DISCLOSURE,
  },
];

/**
 * Block project-bank-self-disclosure ("Selbstauskunft", tab Bank, see feature page projekt-bank): the template to download and the filled-in self-disclosure.
 * `project` is the block data (`Project.blocks.bankSelfDisclosure`); an upload or a delete reloads it. On
 * the unsaved project it shows only a hint.
 */
export default {
  name: 'ProjectBankSelfDisclosure',
  components: { BankAttachmentUpload, BlockFieldset },
  mixins: [AccessBlockMixin, ProjectBankBlockMixin],
  bankBlockField: 'bankSelfDisclosure',
  bankBlockFragment: PROJECT_BANK_SELF_DISCLOSURE_FIELDS,
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return { ATTACHMENT_ROWS, BANK_SELF_DISCLOSURE_TEMPLATE_PATH };
  },
};
</script>

<style scoped lang="scss">
@import '../../styles/bankSectionGrid';
</style>
